import { Tooltip } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { FaBan, FaBinoculars, FaFileAlt, FaFileInvoiceDollar } from "react-icons/fa";
import PaginationV2 from '../../../components/pagination_v2';

const formatDateTime = (value) => {
  if (!value) return '-'
  const date = new Date(value)
  return isNaN(date.getTime())
    ? value
    : new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date)
}

const badgeClasses = {
  live: 'bg-customLightYellow/15 text-customLightYellow dark:bg-customFontYellow/70 dark:text-customHeading',
  settled:
    'bg-customVibrantGreen/15 text-customDarkGreen dark:bg-customDarkGreen/70 dark:text-customHeading',
}

const PAGE_SIZE = 10

const LiveBetTable = ({ data = [], onOpenTicket, onViewTicket, onRejectTicket, isMobile }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const totalItems = data.length
  const totalPages = useMemo(
    () => Math.max(1, Math.ceil(totalItems / PAGE_SIZE)),
    [totalItems]
  )

  useEffect(() => {
    setCurrentPage(1)
  }, [totalItems])

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages)
    }
  }, [currentPage, totalPages])

  const paginatedRows = useMemo(() => {
    const startIndex = (currentPage - 1) * PAGE_SIZE
    const endIndex = startIndex + PAGE_SIZE
    return data.slice(startIndex, endIndex)
  }, [currentPage, data])

  const hasRows = paginatedRows.length > 0
  const startIndex = totalItems === 0 ? 0 : (currentPage - 1) * PAGE_SIZE + 1
  const endIndex = totalItems === 0 ? 0 : Math.min(currentPage * PAGE_SIZE, totalItems)

  return (
    <div className="overflow-hidden rounded-xl border border-customAccentBlue/20 bg-white shadow-lg shadow-customAccentBlue/10 dark:border-customSurface dark:bg-customSurface">
      <header className="flex items-center justify-between border-b border-customPredawn/10 bg-customSlate/60 px-4 py-3 dark:border-customSurfaceMuted dark:bg-custom_dark_primary2/40">
        <div>
          <h3 className="text-base font-semibold text-customPrimaryText dark:text-customHeading">
            Live Betting Feed
          </h3>
          <p className="text-xs text-customSecondaryText dark:text-customMuted">
            Monitor every ticket with channel visibility and rapid drill-down.
          </p>
        </div>
        {/* <button
          type="button"
          onClick={onOpenTicket}
          className="rounded-xl border border-transparent bg-customPredawn dark:bg-customAccent px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-white shadow-md shadow-customRiver/40 transition hover:bg-customRiver/90 focus:outline-none focus:ring-2 focus:ring-customRiver/60 focus:ring-offset-2 dark:hover:bg-customAccent"
        >
          Inspect ticket
        </button> */}
      </header>

      <div className="overflow-x-auto">
        <table className="min-w-full lg:min-w-full divide-y divide-customPredawn/10 text-sm dark:divide-customSurfaceMuted">
          <thead className="bg-background text-left uppercase text-xs font-semibold text-customLightMilkWhite dark:bg-custom_dark_secondary/60 dark:text-customMuted">
            <tr>
              {/* <th className="px-2 py-3 text-customLightMilkWhite dark:text-customMuted">NO</th> */}
              <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">Voucher Info</th>
              {/* <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">Betted Date</th> */}
              <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">User</th>
              <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">Type</th>
              <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">Stake</th>
              <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">Potential</th>
              {/* <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">Channel</th> */}
              <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">Status</th>
              <th className="px-4 py-3 text-customLightMilkWhite dark:text-customMuted">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-customPredawn/5 bg-white dark:divide-customSurfaceMuted/80 dark:bg-customSurface">
            {hasRows ? (
              paginatedRows.map((row) => (
                <tr key={row.id} className="transition hover:bg-customPredawn/5 dark:hover:bg-customSurfaceMuted/60">
                  {/* <td className="px-4 py-3 text-customSecondaryText dark:text-customMuted">{index + 1}</td> */}
                  <td className="px-4 py-2 text-customPrimaryText dark:text-customHeading">
                    <div className='flex flex-col'>
                      <span className="text-sm font-bold tracking-wide text-customInk dark:text-customHeading">{row.id}</span>
                      <span className="mt-0.5 text-xs font-medium text-customSecondaryText dark:text-customMuted">{formatDateTime(row.placedAt)}</span>
                      {/* <span className="font-semibold text-xs px-1">{row.user}</span> */}
                    </div>
                  </td>
                  {/* <td className="px-4 py-3 text-customSecondaryText dark:text-customMuted">
                    {formatDateTime(row.placedAt)}
                  </td> */}
                  <td className="px-4 py-2">
                    <span className="text-sm font-semibold text-customInk dark:text-customHeading">{row.user}</span>
                  </td>
                  <td className="px-2 py-2">
                    <span className="text-sm font-semibold text-customAccentBlue dark:text-customAccent">{row.type}</span>
                  </td>
                  <td className="px-4 py-2">
                    <span className="text-base font-bold tabular-nums text-customInk dark:text-customHeading">
                      {row.stake.toLocaleString('en-US', { maximumFractionDigits: 0 })}
                      <span className="ml-1 text-xs font-semibold text-customSecondaryText dark:text-customMuted">Ks</span>
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    <span className="text-base font-bold tabular-nums text-customDarkGreen dark:text-custom_dark_mint_green">
                      {row.potential.toLocaleString('en-US', { maximumFractionDigits: 0 })}
                      <span className="ml-1 text-xs font-semibold text-customSecondaryText dark:text-customMuted">Ks</span>
                    </span>
                  </td>
                  {/* <td className="px-4 py-3 text-customSecondaryText dark:text-customMuted">{row.channel}</td> */}
                  <td className="px-4 py-2">
                    <span
                      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold transition ${badgeClasses[row.status.toLowerCase()] ?? 'bg-slate-200 text-slate-700 dark:bg-customSurfaceMuted dark:text-customHeading'}`}
                    >
                      <span className='h-2 w-2 rounded-full bg-customLightYellow mr-1'></span>{row.status}
                    </span>
                  </td>
                  <td className='px-2 py-2'>
                    <div className="flex gap-2 items-center">
                      <Tooltip title="View" placement="top" arrow>
                        <button
                          type="button"
                          onClick={() => onViewTicket?.(row)}
                          className="rounded-full bg-customRiver/10 p-2 text-customRiver transition hover:bg-customRiver/20 focus:outline-none focus:ring-2 focus:ring-customRiver/40"
                        >
                          <FaBinoculars className="text-lg" />
                        </button>
                      </Tooltip>
                      <Tooltip title="Reject" placement="top" arrow>
                        <button
                          type="button"
                          onClick={() => onRejectTicket?.(row)}
                          className="rounded-full bg-customFontRed/10 p-2 text-customFontRed transition hover:bg-customFontRed/20 focus:outline-none focus:ring-2 focus:ring-customFontRed/40"
                        >
                          <FaBan className="text-lg" />
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={8}
                  className="px-4 py-8 text-center text-sm font-medium text-customSecondaryText dark:text-customMuted"
                >
                  No live bets available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <PaginationV2
        startIndex={startIndex}
        endIndex={endIndex}
        totalItems={totalItems}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
  )
}

export default LiveBetTable
